// extracted by mini-css-extract-plugin
module.exports = {"content":"PasswordRecoveryForm_content__3yb86","form":"PasswordRecoveryForm_form__2AIcW","input":"PasswordRecoveryForm_input__3cvqV","bottom":"PasswordRecoveryForm_bottom__152p7"};